import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

const CH = [["facebook_instagram", "Facebook + Instagram"], ["facebook", "Solo Facebook"], ["instagram", "Solo Instagram"]];

export default function NewPost({ onSaved }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ content: "", image_url: "", when: "", platform: "facebook_instagram" });
  const save = async () => {
    try {
      await api.post("/social/posts", { content: f.content, image_url: f.image_url, platform: f.platform, scheduled_for: new Date(f.when).toISOString() });
      toast.success("Post programmato"); setOpen(false); setF({ content: "", image_url: "", when: "", platform: "facebook_instagram" }); onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <>
      <Button className="rounded-full bg-ink text-canvas" onClick={() => setOpen(true)} data-testid="new-post-btn"><Plus size={16} className="mr-1" />Programma post</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-canvas max-w-lg" data-testid="new-post-dialog">
          <DialogHeader><DialogTitle className="font-serif text-xl">Nuovo post programmato</DialogTitle></DialogHeader>
          <div className="flex flex-wrap gap-2">
            {CH.map(([k, l]) => (
              <button key={k} onClick={() => setF({ ...f, platform: k })} data-testid={`new-post-ch-${k}`}
                className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${f.platform === k ? "bg-ink text-canvas border-ink" : "border-line text-stone"}`}>{l}</button>
            ))}
          </div>
          <Textarea rows={6} placeholder="Testo del post (con hashtag)" value={f.content} onChange={(e) => setF({ ...f, content: e.target.value })} data-testid="new-post-content" />
          <Input placeholder="Link immagine (https://…) — obbligatorio per Instagram" value={f.image_url} onChange={(e) => setF({ ...f, image_url: e.target.value })} data-testid="new-post-image" />
          <input type="datetime-local" lang="it" value={f.when} onChange={(e) => setF({ ...f, when: e.target.value })} className="w-full rounded-lg border border-line px-3 py-2 text-sm bg-canvas" data-testid="new-post-when" />
          <div className="text-xs text-stone">Viene pubblicato in automatico all'orario scelto sulla Pagina collegata in "Collega Social".</div>
          <div className="flex justify-end"><Button className="rounded-full bg-ink text-canvas" disabled={!f.content || !f.when} onClick={save} data-testid="new-post-save">Programma</Button></div>
        </DialogContent>
      </Dialog>
    </>
  );
}
